import { call, put, takeLatest } from 'redux-saga/effects';
import { api } from 'api/api';
import types from '../types';

/**
 * Saga to fetch products overview for admin vitals page
 * Requires authentication (fixed 2026-09-09 - this endpoint used to be
 * public, see docs/OUTSTANDING_DEFERRED_WORK.md)
 */
function* getProductsOverview({ payload }) {
  try {
    const { token } = payload;
    const { data, status } = yield call(
      api.productAnalytics.getProductsOverview,
      token
    );

    if (status === 200 && data.success) {
      yield put({
        type: types.PRODUCT_ANALYTICS_OVERVIEW_SUCCESS,
        payload: data.products,
      });
    } else {
      yield put({
        type: types.PRODUCT_ANALYTICS_OVERVIEW_ERROR,
        payload: 'Failed to load products',
      });
    }
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to load products';
    yield put({
      type: types.PRODUCT_ANALYTICS_OVERVIEW_ERROR,
      payload: message,
    });
  }
}

/**
 * Saga to fetch product report for specific site
 * @param {Object} payload - Contains siteUrl (preferred) or siteName (legacy), startDate, endDate
 */
function* getProductReport({ payload }) {
  try {
    const { token, siteUrl, siteName, startDate, endDate } = payload;

    // Prefer site_url over site_name (site_url is stable, site_name can change)
    const params = {
      start_date: startDate,
      end_date: endDate,
    };

    if (siteUrl) {
      params.site_url = siteUrl;
    } else if (siteName) {
      // Legacy support
      params.site_name = siteName;
    }

    const { data, status } = yield call(
      api.productAnalytics.getProductReport,
      token,
      params
    );

    if (status === 200 && data.success) {
      yield put({
        type: types.PRODUCT_ANALYTICS_REPORT_SUCCESS,
        payload: data,
      });
    } else {
      yield put({
        type: types.PRODUCT_ANALYTICS_REPORT_ERROR,
        payload: 'Failed to load report',
      });
    }
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to load report';
    yield put({
      type: types.PRODUCT_ANALYTICS_REPORT_ERROR,
      payload: message,
    });
  }
}

/**
 * Watcher saga for product analytics actions
 */
export function* productAnalyticsWatcher() {
  yield takeLatest(types.PRODUCT_ANALYTICS_OVERVIEW_START, getProductsOverview);
  yield takeLatest(types.PRODUCT_ANALYTICS_REPORT_START, getProductReport);
}
